import { render, staticRenderFns } from "./DesignFoundationsSpacing.vue?vue&type=template&id=893f4cdc&scoped=true"
import script from "./DesignFoundationsSpacing.vue?vue&type=script&lang=js"
export * from "./DesignFoundationsSpacing.vue?vue&type=script&lang=js"
import style0 from "./DesignFoundationsSpacing.vue?vue&type=style&index=0&id=893f4cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893f4cdc",
  null
  
)

/* custom blocks */
import block0 from "./DesignFoundationsSpacing.vue?vue&type=custom&index=0&blockType=i18n&locale=ko"
if (typeof block0 === 'function') block0(component)

export default component.exports